import React from 'react';
import PropTypes from 'prop-types';
import {Image, Button} from '@learningblocks/shared-components';
import HintModalIcon from '@common/images/hint-modal-icon.svg';
import './style.scss';

export function HintsModal(props) {
  return (
    <div className='hints-modal'>
      <span className='hints-modal__icon'>
        <Image src={HintModalIcon} alt='hint_icon' />
      </span>
      <h6 className='hints-modal__question'>{props.message}</h6>
      <p className='hints-modal__hintleft'>{props.hintsLeft} Hints Left.</p>
      <div className='hints-modal__buttons'>
        <Button className='noButton' onClick={props.onNo}>
          No
        </Button>
        <Button className='yesButton' onClick={props.onYes}>
          Yes
        </Button>
      </div>
    </div>
  );
}

HintsModal.propTypes = {
  /**
   * Number of hints left
   */
  hintsLeft: PropTypes.number.isRequired,
  /**
   * Function to invoke when Yes is clicked
   */
  onYes: PropTypes.func.isRequired,
  /**
   * Function to invoke when No is clicked
   */
  onNo: PropTypes.func.isRequired,
  /**
   * Message to display on hints component
   */
  message: PropTypes.string.isRequired,
};

HintsModal.defaultProps = {
  hintsLeft: 0,
  message: `Using a hint will eliminate one of your options. Are you sure you want
    to use a hint on this step?`,
};
